package com.macrofocus.eflux.ui.heatmap

import com.macrofocus.common.math.clampNormalize
import com.macrofocus.common.units.Quantity
import com.macrofocus.eflux.network.Link
import com.macrofocus.eflux.network.LinkField

public fun <L: Link> createLinkHeatmapData(
    links: Iterable<L>?,
    backgroundLinks: LinkField<*>?,
    isNotEmpty: (L) -> Boolean,
    interpolate: (L, list: ArrayList<dynamic>, startAmount : Double, endAmount : Double) -> Unit,
    normalized: Boolean,
    relative: Boolean
) : Array<dynamic> {
    val list = ArrayList<dynamic>()
    if(links != null) {
        if(backgroundLinks != null) {
            for (link in links) {
                if(isNotEmpty(link)) {
                    val fromField : LinkField<*>
                    val toField : LinkField<*>
                    when(backgroundLinks) {
                        LinkField.va -> {
                            fromField = LinkField.va_from
                            toField = LinkField.va_to
                        }
                        LinkField.dva -> {
                            fromField = LinkField.va_from
                            toField = LinkField.va_to
                        }
                        LinkField.vm -> {
                            fromField = LinkField.vm_from
                            toField = LinkField.vm_to
                        }
                        LinkField.dvm -> {
                            fromField = LinkField.vm_from
                            toField = LinkField.vm_to
                        }
                        else -> {
                            fromField = backgroundLinks
                            toField = backgroundLinks
                        }
                    }


                    val startValue: Any?
                    val endValue: Any?
                    if(normalized) {
                        val from : Double? = fromField.getNormalized(link)
                        val to : Double? = toField.getNormalized(link)
                        if(from != null && to != null) {
                            if(relative) {
                                // Center of the slope -> (from + to)  / 2
                                // -1..+1 -> start = -1 - 0, end +1 - 0
                                val center = (from + to) / 2.0
                                startValue = (from - center).clampNormalize(-1.0, 1.0)
                                endValue = (to - center).clampNormalize(-1.0, +1.0)
                            } else {
                                startValue = from
                                endValue = to
                            }
                        } else {
                            startValue = null
                            endValue = null
                        }
                    } else {
                        startValue = fromField.getValue(link)
                        endValue = toField.getValue(link)
                    }
                    val startAmount : Double?
                    if(startValue is Number) {
                        startAmount = startValue.toDouble()
                    } else if(startValue is Quantity<*>) {
                        startAmount = startValue.amount
                    } else {
                        startAmount = null
                    }
                    val endAmount : Double?
                    if(endValue is Number) {
                        endAmount = endValue.toDouble()
                    } else if(endValue is Quantity<*>) {
                        endAmount = endValue.amount
                    } else {
                        endAmount = null
                    }
                    if(startAmount != null && endAmount != null) {
                        interpolate(link, list, startAmount, endAmount)
                    }
                }
            }
        }
    }

    return list.toTypedArray()
}